module.exports = {"attributes":{"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"},"content":"<text class='channel-icon-logo' style=\"white-space: pre; font-family: Arial, sans-serif; font-weight: 700; font-size: 160px;\" x=\"43.382\" y=\"152.504\">V</text>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/type_video.svg
// module id = 1374
// module chunks = 0